
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Betslip from '../../components/odds/betslip/Betslip';
import LiveGamesList from '../../components/odds/live/LiveGamesList';
import { LiveSportFilter } from '../../components/odds/live/LiveSportFilter';
import View from '../../components/layout/View';
import OpenBetsWidget from '../../components/widgets/OpenBetsWidget';
import { PageFilterType } from '../../filter/types';
import { useContentClient } from '../../lib/api-client';
import { CmsPageIdentifier } from '../../lib/content';
import { buildSessionData, withPageSession } from '../../lib/session';
const Live = () => {
    return <LiveGamesList />;
};
Live.getLayout = function getLayout(_t, _pageProps, page) {
    return (<View pageId="live-page" headerProps={{ addStakeSelector: true, addBonusBanner: true }} leftWidgets={[<LiveSportFilter />]} rightWidgets={[<OpenBetsWidget orientation="vertical"/>, <Betslip mode="desktop" dropShadow/>]} addFooter={false}>
      {page}
    </View>);
};
const getServerSideProps = withPageSession(async ({ req, session, locale }, _pageFilterResult, pageData) => {
    const contentClient = useContentClient();
    const sessionId = session.get('sessionId');
    const token = session.get('token');
    const sessionData = buildSessionData(req, sessionId, token);
    const sportsBettingSettings = await contentClient.getSportsBettingSettings(sessionData);
    if (!sportsBettingSettings.liveEnabled) {
        return {
            redirect: {
                destination: `/${locale}/sports`,
                permanent: false,
            },
        };
    }
    return {
        props: {
            ...pageData,
        },
    };
}, CmsPageIdentifier.Live, [PageFilterType.PageRequiresAuthentication]);
export default Live;

    async function __Next_Translate__getServerSideProps__1970be5a093__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sports/live',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1970be5a093__ as getServerSideProps }
  